/*
 * @Description: new file
 * @Autor: zlh
 * @Date: 2022-01-26 10:10:10
 * @LastEditors: zlh
 * @LastEditTime: 2022-04-28 13:43:06
 */
// 前端视频类静态资源配置文件
// 请在 /upload/source 页面上传资源，然后获取上传的视频资源名称及路径在这里配置
// import con /config/pre-pro.conf.js
 // eslint-disable-next-line no-undef
 const base_url = getEnv('prod').guideVideoUrl
//  const base_url = getEnv('prod').photoDomain
export default {
  // 开发环境
  dev:{},
  // 测试环境
  test: {},
  // 预生产
  pre: {},
  // 生产
  pro:{
    //首页视频资源
    'ai-block-editor-1':`${base_url}/aishixun/20220518/14/0d28062cc6114fe289913e74462ac111.mp4`,
    'ai-block-editor-2':`${base_url}/aishixun/20220518/14/f4a614a47dc54c72b8a94f470233974d.mp4`,
    'ai-block-editor-3':`${base_url}/aishixun/20220518/14/248e2217cdbc42919e79a484399b0d61.mp4`,
    'ai-code-editor-1':`${base_url}/aishixun/20220518/14/c1a39f471b4c4cf7891f8a81aaa06716.mp4`,
    'ai-code-editor-2':`${base_url}/aishixun/20220518/14/daf14705f2a040f686a23f42f207bcd1.mp4`,
    'ai-code-editor-3':`${base_url}/aishixun/20220518/14/672b0f9f2263493e92d653a2318ee38a.mp4`,
    'ai-code-editor-4':`${base_url}/aishixun/20220518/14/27c6868e2c444e7d8cfae7021fa43320.mp4`,
    'ai-editor':`${base_url}/aishixun/20220126/13/91d2812488f1401ca088bd9261ddea0d.mp4`,
    //新手指引视频资源
    //block积木编辑器
    'guide_editor_b_1':`${base_url}/aishixun/20220518/14/a7167f862dae4bba95d03da7b6952b03.mp4`,
    'guide_editor_b_2':`${base_url}/aishixun/20220518/14/0bad816108824a46aa96022fa2825efe.mp4`,
    'guide_editor_b_3':`${base_url}/aishixun/20220518/14/619947db56cc4380b9e3261b35cf2bf1.mp4`,
    'guide_editor_b_4':`${base_url}/aishixun/20220518/14/8c96281c5bb14834a9c49269e3b37342.mp4`,
    'guide_editor_b_5':`${base_url}/aishixun/20220518/14/d178883adaba471987faab0a12866892.mp4`,
    //python 代码类编辑器 
    'guide_editor_p_1':`${base_url}/aishixun/20220518/14/c1a39f471b4c4cf7891f8a81aaa06716.mp4`,
    'guide_editor_p_2':`${base_url}/aishixun/20220518/14/daf14705f2a040f686a23f42f207bcd1.mp4`,
    'guide_editor_p_3':`${base_url}/aishixun/20220518/14/672b0f9f2263493e92d653a2318ee38a.mp4`,
    'guide_editor_p_4':`${base_url}/aishixun/20220518/14/27c6868e2c444e7d8cfae7021fa43320.mp4`,
  }
}
